import $ from 'jquery';
import AsyncView from 'shopify-asyncview';
import morphdom from 'morphdom';
import LineItem from '../components/LineItem';
import ShippingCalculator from '../components/ShippingCalculator';
import CartRequests from '../utils/CartRequests';

export default class StaticCart {
  constructor(section) {
    this.section = section;

    this.updateNote = this._updateNote.bind(this);

    const itemEls = section.el.querySelectorAll('[data-line-item]');

    this.items = [];

    for (let i = 0; i < itemEls.length; i++) {
      this.items.push(new LineItem(itemEls[i]));
    }

    const shippingCalculatorEl = section.el.querySelector('[data-shipping-calculator]');

    if (shippingCalculatorEl) {
      this.shippingCalculator = new ShippingCalculator(shippingCalculatorEl);
    }

    this.cartNoteEl = section.el.querySelector('[data-cart-note]');

    if (this.cartNoteEl) {
      this.cartNoteEl.addEventListener('change', this.updateNote);
    }

    $(window).on('cart-loading-start', this._onUpdateStart.bind(this));
    $(window).on('cart-loading-finish', this._onUpdateFinish.bind(this));
  }

  _onUpdateStart() {
    this.section.el.classList.add('cart-updating');
  }

  _onUpdateFinish() {
    AsyncView.load(
      window.Theme.routes.cart_url,
      { view: 'ajax' },
    ).then(({ data, html }) => {
      if (data.item_count === 0) {
        this._unload();
        const form = this.section.el.querySelector('[data-cart]');
        const shipping = this.section.el.querySelector('[data-shipping-calculator]');

        if (form) {
          form.parentNode.removeChild(form);
        }

        if (shipping) {
          shipping.parentNode.removeChild(shipping);
        }
      }

      const itemsEl = this.section.el.querySelector('[data-cart-items]');
      const noteEl = this.section.el.querySelector('[data-cart-note]');
      const totalsEl = this.section.el.querySelector('[data-cart-totals]');
      const newItemsEl = document.createElement('div');
      const newNoteEl = document.createElement('div');
      const newTotalsEl = document.createElement('div');

      // This should be removed and the update should occur locally to the element
      $('.cart-link .cart-count').text(data.item_count);

      if (itemsEl && html.cart_items) {
        newItemsEl.innerHTML = html.cart_items;

        morphdom(
          itemsEl,
          newItemsEl,
          {
            childrenOnly: true,
            onBeforeElUpdated: (fromEl, toEl) => {
              // Skip images if src matches
              // - we don't want to reload lazy loaded images
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }

              return true;
            },
          },
        );
      }

      if (noteEl && html.cart_note) {
        newNoteEl.innerHTML = html.cart_note;

        morphdom(
          noteEl,
          newNoteEl,
        );
      }

      if (totalsEl && html.cart_totals) {
        newTotalsEl.innerHTML = html.cart_totals;

        morphdom(
          totalsEl,
          newTotalsEl,
          {
            childrenOnly: true,
          },
        );
      }

      this.items.forEach(item => item.unload());
      this.items = [];

      const itemEls = this.section.el.querySelectorAll('[data-line-item]');

      for (let i = 0; i < itemEls.length; i++) {
        this.items.push(new LineItem(itemEls[i]));
      }

      this.section.el.classList.remove('cart-updating');

      this.cartNoteEl = this.section.el.querySelector('[data-cart-note]');

      if (this.cartNoteEl) {
        this.cartNoteEl.addEventListener('change', this.updateNote);
      }
    });
  }

  _updateNote() {
    CartRequests.updateNote(this.cartNoteEl.value);
  }

  _unload() {
    this.items.forEach(item => item.unload());

    if (this.shippingCalculator) {
      this.shippingCalculator.unload();
    }

    if (this.cartNoteEl) {
      this.cartNoteEl.removeEventListener('change', this.updateNote);
    }
  }

  onSectionUnload() {
    this._unload();
  }
}
